// extracted by mini-css-extract-plugin
export default {"sub-title":"styles_sub-title__zatzm","row":"styles_row__uUIK1","label":"styles_label__e5SyV"};